<template>
  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css" rel="stylesheet">
  <v-layout class="rounded rounded-md">
    <v-app-bar app dense height="48" class="d-flex justify-between">

      <v-container class="flex-fill text-left d-flex align-left justify-start">
      </v-container>

      <v-container class="flex-fill text-center d-flex align-center justify-center">
      </v-container>

      <v-container class="flex-fill text-center d-flex align-center justify-end">

        <v-menu v-if="loggedIn">
          <template v-slot:activator="{ props }">
            <v-btn color="transparent" v-bind="props" class="no-uppercase text-body-2 text-black">
              <span class="ma-2 text-grey-darken-3 text-caption" v-if="loggedIn">{{ email }}</span>
              <ProfileCircle :name="username" v-if="loggedIn" />
            </v-btn>
          </template>
          <v-list class="ma-0 pa-0">
            <v-list-item class="ma-0 pa-0">
              <v-btn class="w-100" prepend-icon="mdi-cog" size="small" @click="showSettings = true; loadSettings()">
                Settings
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn class="w-100" prepend-icon="mdi-logout" size="small" levation="4" @click="logout">
                Logout
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-container>
    </v-app-bar>
    <v-snackbar v-model="showSnackbar" timeout="5000" color="error" top>
      ⚠️ Nicht genügend Rechte im aktuellen Profil freigeschaltet!
      <template #action>
        <v-btn text @click="closeSnackbar">Schließen</v-btn>
      </template>
    </v-snackbar>
    <v-main :style="{ width: '100%' }">
      <router-view v-slot="{ Component }" @login-success="handleSuccessfulLogin">
        <transition name="fade" mode="out-in">
          <component :is="Component" :isMobile="isMobile" />
        </transition>
      </router-view>
    </v-main>

    <!-- Settings Modal -->
    <v-dialog v-model="showSettings" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Settings</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="settingsN8nHost"
            label="n8n Instance URL"
            placeholder="https://n8n.hpc-hamburg.de"
            hint="Your n8n instance URL (without /api/v1)"
            persistent-hint
            variant="outlined"
            density="comfortable"
            class="mt-2"
          ></v-text-field>
          <v-text-field
            v-model="settingsN8nApiKey"
            label="n8n API Key"
            placeholder="Enter your n8n API key"
            :type="showN8nKey ? 'text' : 'password'"
            :append-inner-icon="showN8nKey ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append-inner="showN8nKey = !showN8nKey"
            hint="Required for the Workflow Builder agent"
            persistent-hint
            variant="outlined"
            density="comfortable"
            class="mt-4"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="showSettings = false">Cancel</v-btn>
          <v-btn color="primary" variant="flat" :loading="savingSettings" @click="saveSettings">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="settingsSnackbar" timeout="3000" color="success">
      Settings saved
    </v-snackbar>

  </v-layout>
</template>

<script>
import ProfileCircle from "./components/ProfileCircle.vue";
import axios from 'axios';
import config from './config.js';
import { useRouter } from "vue-router";

export default {
  components: {
    ProfileCircle,
  },
  data() {
    return {
      drawer: true,
      isMobile: false,
      loggedIn: localStorage.getItem('token'),
      username: '',
      email: '',
      showSnackbar: false,
      showSettings: false,
      showN8nKey: false,
      settingsN8nApiKey: '',
      settingsN8nHost: 'https://n8n.hpc-hamburg.de',
      savingSettings: false,
      settingsSnackbar: false,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.getUser();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async getUser() {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Token not found in localStorage');
      }
      const headers = {
        Authorization: `Token ${token}`
      }

      const response = await axios.get(`${config.baseURL}/api/v1/user/me/`, { headers }).catch(e => {
        this.$router.push('/login');
      })
      if (response.status == 200) {
        const user_json = response.data
        this.username = user_json.first_name + ' ' + user_json.last_name
        this.email = user_json.email
      }
    },
    async loadSettings() {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const resp = await axios.get(`${config.baseURL}/api/v1/user/settings/`, {
          headers: { Authorization: `Token ${token}` },
        });
        this.settingsN8nApiKey = resp.data.n8n_api_key_set ? '••••••••••••••••' : '';
        this.settingsN8nHost = (resp.data.n8n_host || 'https://n8n.hpc-hamburg.de/api/v1').replace(/\/api\/v1$/, '');
      } catch (e) { /* ignore */ }
    },
    async saveSettings() {
      const token = localStorage.getItem('token');
      if (!token) return;
      this.savingSettings = true;
      try {
        const payload = {};
        if (this.settingsN8nApiKey && !this.settingsN8nApiKey.startsWith('••')) {
          payload.n8n_api_key = this.settingsN8nApiKey;
        }
        if (this.settingsN8nHost) {
          payload.n8n_host = this.settingsN8nHost;
        }
        await axios.post(`${config.baseURL}/api/v1/user/settings/`, payload, {
          headers: { Authorization: `Token ${token}`, 'Content-Type': 'application/json' },
        });
        this.showSettings = false;
        this.settingsSnackbar = true;
      } catch (e) {
        console.error('Failed to save settings', e);
      } finally {
        this.savingSettings = false;
      }
    },
    async logout() {
      this.$router.push('/logout');
      this.loggedIn = false;
    },
    handleSuccessfulLogin() {
      this.loggedIn = true;
      this.getUser();
    },
    handleResize() {
      this.isMobile = (window.innerWidth < 765);
      console.log(this.isMobile)
      this.drawer = !this.isMobile;
    },
    openComponentHome() {
      this.$router.push('/');
    },
    openComponentDigitalAssistant() {
      this.$router.push('/chatbot');
    },
    openComponentBiDashboard() {
      this.$router.push('/bi-dashboard');
    },
    openComponentAiDashboard() {
      this.$router.push('/ai-dashboard');
    },
    openComponentSharepoint() {
      // this.activeWindow = 'sharepoint';
      this.$router.push('/sharepoint');
    },
    openComponentDigitalTriplet() {
      this.$router.push('/digitaltriplet');
    },
    openComponentMarketAnalyzer() {
      this.$router.push('/marketanalyzer');
    },
    openComponentMarketAnalyzer() {
      this.$router.push('/marketanalyzer');
    },
    openComponentChatbot() {
      this.$router.push('/chatbot');
    }
  },
};
</script>

<style scoped>
.no-uppercase {
     text-transform: unset !important;
}

.v-app-bar {
  min-height: 48px !important;
  max-height: 48px !important;
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(24px) !important;
  -webkit-backdrop-filter: blur(24px) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04) !important;
}

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
  background-color: white;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #002394aa);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
